"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitToGoogleAnalytics = void 0;
var SplitToGa_1 = require("./SplitToGa");
function SplitToGoogleAnalytics(options) {
    if (options === void 0) { options = {}; }
    // SplitToGa integration factory
    function SplitToGoogleAnalyticsFactory(params) {
        return new SplitToGa_1.SplitToGa(params.settings.log, options);
    }
    SplitToGoogleAnalyticsFactory.type = 'SPLIT_TO_GOOGLE_ANALYTICS';
    return SplitToGoogleAnalyticsFactory;
}
exports.SplitToGoogleAnalytics = SplitToGoogleAnalytics;
